import config from '../config/config';

const credentials = {
  claveDeEncripcion: config.claveDeEncripcion,
  idSistema: config.idSistema,
  gateWay: config.gateWay,
};

export default credentials;
